import axios from "axios";
import UserService from "./UserService";
const BASE_URL = 'https://local.my.homecarepulse.com:3000/';
const HttpMethods = {
    GET: 'GET',
    POST: 'POST',
    DELETE: 'DELETE',
  };
  
  const _axios = axios.create({BASE_URL});
  
  const configure = () => {
    _axios.interceptors.request.use((config) => {
      if (UserService.isLoggedIn()) {
        const cb = () => {
          config.headers.Authorization = `Bearer ${UserService.getToken()}`;
          return Promise.resolve(config);
        };
        return UserService.updateToken(cb);
      }
    });
  };
  
  const getAxiosClient = () => _axios;
  
  const HttpService = {
    HttpMethods,
    configure,
    getAxiosClient,
  };
  
  export default HttpService;